import React, { Component, Fragment } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button } from "../../../../revvComponents";

// Component Import
import CreateAssetFolderPopup from "../../../AssetWrapper/AssetLeftSection/CreateAssetFolderPopup";

// Internal Imports
import { GlobalUtils } from "../../../../utils";

// Destructuring
const { truncateString } = GlobalUtils;

// eslint-disable-next-line react/prefer-stateless-function
class FolderManagerPopup extends Component {
  state = {
    selectedBredcrumb: null,
    breadcrumbData: [],
    // We need old data when we create a new folder inside another folder
    oldbreadcrumbData: [],
    showCreateFolderPopup: false,
    currentFolderID: null,
  };

  componentDidMount() {
    const { assetBreadcrumbData } = this.props;
    let selectedBredcrumb = null;
    if (assetBreadcrumbData && assetBreadcrumbData.length > 0) {
      selectedBredcrumb = assetBreadcrumbData[assetBreadcrumbData.length - 1];
    }
    this.setState({
      breadcrumbData: assetBreadcrumbData,
      oldbreadcrumbData: assetBreadcrumbData,
      selectedBredcrumb,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { assetBreadcrumbData } = this.props;
    const { assetFoldersTree } = nextProps;
    const { oldbreadcrumbData, selectedBredcrumb } = this.state;
    const { crmFoldersTree, normalFoldersTree } = assetFoldersTree;
    assetBreadcrumbData[0] = {
      ...assetBreadcrumbData[0],
      children: [...normalFoldersTree, ...crmFoldersTree],
    };
    const updateBreadCrumData = [...oldbreadcrumbData];
    updateBreadCrumData[0].children = [...assetBreadcrumbData[0].children];
    if (selectedBredcrumb && selectedBredcrumb.name === "All") {
      this.setState({
        breadcrumbData: updateBreadCrumData,
        selectedBredcrumb: assetBreadcrumbData[assetBreadcrumbData.length - 1],
      });
    } else
      this.setState({
        breadcrumbData: updateBreadCrumData,
      });
  }

  _activeBreadcrumbClassName = (id, index) => {
    const { selectedBredcrumb, breadcrumbData } = this.state;
    let className = "";
    if (selectedBredcrumb) {
      if (selectedBredcrumb.id === id) {
        className = "active-bredcrumb";
      }
    } else if (index === breadcrumbData.length - 1) {
      className = "active-bredcrumb";
    }

    return className;
  };

  _handleBredcrumbClick = bredcrumbId => {
    const { oldbreadcrumbData } = this.state;
    let tempBcData = null;
    oldbreadcrumbData.forEach((bc, index) => {
      if (bc.id === bredcrumbId) {
        tempBcData = {
          index,
          findBredcrumb: bc,
        };
      }
    });
    if (tempBcData) {
      const tempBreadcrumbData = oldbreadcrumbData.slice(
        0,
        tempBcData.index + 1,
      );
      this.setState({
        selectedBredcrumb: tempBcData.findBredcrumb,
        breadcrumbData: tempBreadcrumbData,
        oldbreadcrumbData: tempBreadcrumbData,
      });
    }
  };

  _getBredcrumbs = () => {
    const { oldbreadcrumbData } = this.state;
    return oldbreadcrumbData.map((bc, index) => (
      <div className="assetmovetofolder-bredcrumb-item" key={bc.id}>
        <span
          className={`assetmovetofolder-bredcrumb-text ${this._activeBreadcrumbClassName(
            bc.id,
            index,
          )}`}
          onClick={() => this._handleBredcrumbClick(bc.id)}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <Tooltip
            placement="top"
            align={{
              offset: [0, 4],
            }}
            overlay={`${
              bc.name.length > 16 ? truncateString(bc.name, 16, true) : bc.name
            }`}>
            <div>{bc.name ? truncateString(bc.name, 16, true) : null}</div>
          </Tooltip>
        </span>
        {index < oldbreadcrumbData.length - 1 && (
          <FontAwesomeIcon
            icon={["far", "angle-right"]}
            className="assetmovetofolder-bredcrumb-icon"
          />
        )}
      </div>
    ));
  };

  _getFolderRow = (isCRMRootFolder, folderName) => (
    <div className="assetmovetofolder-selectfolder-col">
      {isCRMRootFolder ? (
        <span className="assetmovetofolder-icon-wrapper">
          <FontAwesomeIcon
            icon={["fal", "folder"]}
            className="assetmovetofolder-selectfolder-icon crm-folder-icon show-hover"
          />
          <FontAwesomeIcon
            icon={["fas", "folder"]}
            className="assetmovetofolder-selectfolder-icon crm-folder-icon hide-hover"
          />
          <FontAwesomeIcon
            icon={["far", "link"]}
            className="folder-link-icon"
          />
        </span>
      ) : (
        <Fragment>
          <FontAwesomeIcon
            icon={["fal", "folder"]}
            className="assetmovetofolder-selectfolder-icon folder-icon show-hover"
          />
          <FontAwesomeIcon
            icon={["fas", "folder"]}
            className="assetmovetofolder-selectfolder-icon folder-icon hide-hover"
          />
        </Fragment>
      )}

      <span className="assetmovetofolder-selectfolder-title">
        {folderName || "-"}
      </span>
    </div>
  );

  _handleFolderSelection = selectedFolderID => {
    const { breadcrumbData, selectedBredcrumb } = this.state;
    let tempBcData = null;
    if (selectedBredcrumb) {
      tempBcData = selectedBredcrumb.children.find(
        sbc => sbc.id === selectedFolderID,
      );
    }
    if (tempBcData) {
      const tempBreadcrumbData = [...breadcrumbData];
      tempBreadcrumbData.push(tempBcData);
      this.setState({
        breadcrumbData: tempBreadcrumbData,
        oldbreadcrumbData: tempBreadcrumbData,
        selectedBredcrumb: tempBcData,
        currentFolderID: selectedFolderID,
      });
    }
  };

  _getFolderList = () => {
    const { selectedBredcrumb, breadcrumbData } = this.state;
    let folderList = { children: [] };
    if (selectedBredcrumb) {
      folderList = selectedBredcrumb;
    } else if (breadcrumbData.length === 0) {
      folderList = { ...breadcrumbData[0] };
    } else if (breadcrumbData.length >= 1) {
      folderList = breadcrumbData[breadcrumbData.length - 1];
    }
    if (folderList.children && folderList.children.length > 0) {
      return folderList.children.map(folder => {
        const {
          opportunity_id: oppId,
          opportunity_root: OppRoot,
          // access_level: accessLevel,
        } = folder;
        let isCRMRootFolder = false;
        if (oppId && OppRoot) {
          isCRMRootFolder = true;
        }
        return (
          <div
            className="assetmovetofolder-selectfolder-row"
            onClick={() => this._handleFolderSelection(folder.id)}
            onKeyPress={() => {}}
            role="button"
            tabIndex="0"
            key={folder.id}>
            {this._getFolderRow(isCRMRootFolder, folder.name)}
          </div>
        );
      });
    }
    return null;
  };

  _handleCreateFolderPopup = () => {
    const selectedFolderID = this.state.selectedBredcrumb.id;
    this.setState({
      showCreateFolderPopup: true,
      currentFolderID: selectedFolderID || null,
    });
  };

  _toggleCreateAssetFolderPopup = () =>
    this.setState({ showCreateFolderPopup: false });

  render() {
    return (
      <Fragment>
        {this.state.showCreateFolderPopup && (
          <CreateAssetFolderPopup
            show={this.state.showCreateFolderPopup}
            closePopup={this._toggleCreateAssetFolderPopup}
            associatedFolderId={this.state.currentFolderID}
            history={this.props.history}
          />
        )}
        <Modal
          open
          onClose={this.props.closePopup}
          closeOnOverlayClick={false}
          center>
          <div className="docrecipientspopup-container folder-container">
            {/* ----------- Modal Heading Section ----------- */}
            <div
              className="modal-heading"
              data-test="addrecipientspopup-modal-heading">
              Select a folder to keep the bulk documents
            </div>

            <div className="docsharingpopup-sharingform-title">
              Select a folder or create a new folder to keep all the bulk
              documents organised
            </div>

            {/* ---------- Bredcrumb Section ---------- */}
            <div className="assetmovetofolder-bredcrumb-wrapper folder-bredcrumb-wrapper">
              {this._getBredcrumbs()}
            </div>

            <div
              className="create-folder-btn"
              role="button"
              tabIndex={0}
              onClick={() => {
                this._handleCreateFolderPopup();
              }}
              onKeyDown={() => {}}>
              + Create new folder
            </div>

            {/* ---------- Select Folder Section ---------- */}
            <div className="assetmovetofolder-folderlist-wrapper">
              {this._getFolderList()}
            </div>

            {/* ----------- Modal Footer Section ----------- */}
            <div className="modal-footer folder-footer">
              <Button
                id="addrecipientspopup-cancle-btn"
                className="btn btn-transparent modal-footer-btn cancle-btn"
                data-test="addrecipientspopup-cancle-btn"
                onClick={this.props.closePopup}>
                Back
              </Button>
              <Button
                data-test="docsharing-popup-share-btn"
                className="btn btn-success docsharingpopup-sharebtn"
                onClick={() =>
                  this.props.getFolderPath(
                    this.state.breadcrumbData,
                    this.state.currentFolderID,
                  )
                }>
                Select folder
              </Button>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { assetFoldersTree, assetFolderContent } = state.AssetStore;
  return {
    assetFoldersTree,
    assetFolderContent,
  };
};

export default connect(mapStateToProps, null)(FolderManagerPopup);
